import React, { useEffect, createRef } from 'react';
import gsap from 'gsap';

import { Svg } from './failSvg.styled';

function FailSvg() {
  const circleRef = createRef();
  const circleLineRef = createRef();

  const tl = gsap.timeline();

  useEffect(() => {
    tl.fromTo(
      circleRef.current,
      1,
      { opacity: 1, scaleX: 0, transformOrigin: 'left' },
      { scaleX: 1, transformOrigin: 'left' }
    ).to(circleLineRef.current, 1, { opacity: 1 });
  });

  return (
    <Svg
      version="1.1"
      id="Warstwa_1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 458 408"
      className="st3"
    >
      <g>
        <path
          className="st0"
          ref={circleRef}
          d="M229,32.82c47.46,0,92.09,18.48,125.65,52.05c33.56,33.56,52.05,78.19,52.05,125.65s-18.48,92.09-52.05,125.65
		c-33.56,33.56-78.19,52.05-125.65,52.05s-92.09-18.48-125.65-52.05C69.79,302.6,51.3,257.98,51.3,210.52
		c0-47.46,18.48-92.09,52.05-125.65S181.54,32.82,229,32.82 M229,14.82c-108.08,0-195.7,87.62-195.7,195.7s87.62,195.7,195.7,195.7
		s195.7-87.62,195.7-195.7S337.08,14.82,229,14.82L229,14.82z"
        />
      </g>
      <g ref={circleLineRef} className="st2">
        <line className="st1" x1="125.07" y1="129.98" x2="191.87" y2="196.79" />
        <line className="st1" x1="115.23" y1="196.79" x2="195.76" y2="116.25" />
        <line className="st1" x1="262.87" y1="129.98" x2="329.68" y2="196.79" />
        <line className="st1" x1="253.04" y1="196.79" x2="333.57" y2="116.25" />
        <line className="st1" x1="140.23" y1="311.54" x2="327.52" y2="262.36" />
      </g>
    </Svg>
  );
}

export default FailSvg;
